import React, { useEffect, useState } from "react";

const initialForm = {
  employeeId: "",
  employeeName: "",
  department: "",
  designation: "",
  salaryStructure: "",
  effectiveDate: "",
  status: "Active",
  remarks: "",
};

export default function EmployeeSalaryAssignmentModal({
  isOpen,
  onClose,
  onSave,
  initialData,
  employees,
  salaryStructures,
}) {
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData(initialForm);
    }
  }, [initialData, isOpen]);

  if (!isOpen) return null;

  const handleEmployeeChange = (employeeId) => {
    const employee = employees.find(
      (emp) => emp.employeeId === employeeId
    );

    if (!employee) return;

    setFormData((prev) => ({
      ...prev,
      employeeId: employee.employeeId,
      employeeName: employee.employeeName,
      department: employee.department,
      designation: employee.designation,
    }));
  };

  const handleSubmit = () => {
    if (!formData.employeeId) {
      alert("Please select an employee.");
      return;
    }

    if (!formData.salaryStructure) {
      alert("Please select a salary structure.");
      return;
    }

    if (!formData.effectiveDate) {
      alert("Please select an effective date.");
      return;
    }

    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div
        className="finance-modal"
        style={{ width: "800px", maxWidth: "95%" }}
      >
        <div className="finance-modal-header">
          <h2>
            {initialData
              ? "Edit Salary Assignment"
              : "Assign Salary Structure"}
          </h2>
        </div>

        <div className="finance-modal-body">

          <div className="form-group">
            <label>Employee *</label>

            <select
              className="finance-select"
              value={formData.employeeId}
              onChange={(e) =>
                handleEmployeeChange(e.target.value)
              }
            >
              <option value="">Select Employee</option>

              {employees.map((employee) => (
                <option
                  key={employee.employeeId}
                  value={employee.employeeId}
                >
                  {employee.employeeId} - {employee.employeeName}
                </option>
              ))}
            </select>
          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Department</label>

              <input
                className="finance-input"
                value={formData.department}
                readOnly
              />
            </div>

            <div className="form-group">
              <label>Designation</label>

              <input
                className="finance-input"
                value={formData.designation}
                readOnly
              />
            </div>

          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Salary Structure *</label>

              <select
                className="finance-select"
                value={formData.salaryStructure}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    salaryStructure: e.target.value,
                  })
                }
              >
                <option value="">
                  Select Salary Structure
                </option>

                {salaryStructures.map((structure) => (
                  <option
                    key={structure.id}
                    value={structure.structureName}
                  >
                    {structure.structureName}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Effective Date *</label>

              <input
                type="date"
                className="finance-input"
                value={formData.effectiveDate}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    effectiveDate: e.target.value,
                  })
                }
              />
            </div>

          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Status</label>

              <select
                className="finance-select"
                value={formData.status}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    status: e.target.value,
                  })
                }
              >
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>

          </div>

          <div className="form-group">
            <label>Remarks</label>

            <textarea
              rows="3"
              className="finance-input"
              placeholder="Enter remarks..."
              value={formData.remarks}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  remarks: e.target.value,
                })
              }
            />
          </div>

        </div>

        <div className="finance-modal-footer">
          <button
            className="finance-secondary-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="finance-primary-btn"
            onClick={handleSubmit}
          >
            Save Assignment
          </button>
        </div>
      </div>
    </div>
  );
}